import { Route, Switch } from "react-router-dom";
import Pagina404 from './pages/Pagina404';
import Login from './pages/Login';
import Assessorados from "./pages/Assessorados";
import Detalhes from "./pages/Detalhes";
import SolicitarRedefinicaoSenha from "./pages/RedefinirSenha/SolicitarRedefinicaoSenha";
import RedefinicaoSenha from "./pages/RedefinirSenha/RedefinicaoSenha";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";

function Routes() {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/redefinir-senha" component={SolicitarRedefinicaoSenha} />
      <Route exact path="/redefinir-senha/:id" component={RedefinicaoSenha} />

      <Header>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/assessorados" component={Assessorados} />
        <Route exact path="/assessorados/:id" component={Detalhes} />
      </Header>
      
      <Route exact component={Pagina404} />
    </Switch>
  );
}

export default Routes;
